import { FormattedMessage } from 'react-intl';

import { Timer } from '@sorare/core/src/atoms/icons/Timer';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { LabelM } from '@sorare/core/src/atoms/typography';
import TimeLeft from '@sorare/core/src/contexts/ticker/TimeLeft';

type Props = { nextArenaFreePlayAvailableAt: Date | null };
export const FreePlayTimer = ({ nextArenaFreePlayAvailableAt }: Props) => {
  if (!nextArenaFreePlayAvailableAt) {
    return null;
  }

  return (
    <Horizontal gap={0.5} center>
      <Timer color="var(--c-rivals-reputation)" />
      <LabelM color="var(--c-neutral-700)" bold>
        <FormattedMessage
          id="FreePlayTimer.freePlayAvailableIn"
          defaultMessage="Next free play available in {timeLeft}"
          values={{
            timeLeft: <TimeLeft time={nextArenaFreePlayAvailableAt} />,
          }}
        />
      </LabelM>
    </Horizontal>
  );
};
